import { User } from "../context/AuthContext";
import { SystemsDispatch } from "../context/SystemContext";
import { getBackendUrl } from "../env";

export const getSystemById = async (user:User, id:string) => {
    const response = await fetch(`${getBackendUrl()}/api/systems/`+id, {
        method: 'GET',
        headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${user.token}`
        } 
    })
    const json = await response.json()
    if(response.ok){
        return json
    }
}


export const fetchSystems = async (user: User, dispatch: SystemsDispatch, userDispatch: any) => {
  
  const response = await fetch(`${getBackendUrl()}/api/systems`, {
    headers: {'Authorization': `Bearer ${user.token}`},
  }).catch((error) => {
    console.error('Error fetching systems:', error);
  });
  if (!response) {
    return;
  }
  
  const json = await response.json();
  
  if (response.ok) {
    dispatch({type: 'SET_SYSTEM', payload: json});
  }
  else if(response.status === 401){
    console.log("401 error, logging out");
    userDispatch({type: 'LOGOUT'});
  }
}